export enum ENV {
    local = 'local',
    dev = 'dev',
    stg = 'stg',
    prd = 'prd',
}

export const CURRENT_ENV: ENV = process.env.REACT_APP_ENV as ENV;
